import { Controller } from "@hotwired/stimulus"

/**
 * Öffnet ein Modal anhand seiner ID — unabhängig davon wo der Trigger steht.
 *
 * Verwendung:
 *   %a{ data: { controller: 'modal-trigger', modal_trigger_target_value: 'customer-todo-modal', action: 'click->modal-trigger#open' } }
 *     Aufgabe erstellen
 *
 * Sucht im DOM nach dem Element mit der ID und klickt dessen .modal-button,
 * oder öffnet ein <dialog> via showModal().
 */
export default class extends Controller {
  static values = { target: String }

  open(event) {
    event.preventDefault()
    const id = this.targetValue
    if (!id) return

    // Option 1: <dialog> Element
    const dialog = document.getElementById(id)
    if (dialog && dialog.tagName === "DIALOG") {
      dialog.showModal()
      return
    }

    // Option 2: tmodal — klicke den .modal-button innerhalb des tmodal-Controllers
    const modal = document.getElementById(id)
    if (modal) {
      const btn = modal.querySelector(".modal-button, [data-action*='tmodal#open']")
      if (btn) { btn.click(); return }
    }

    // Option 3: finde ein tmodal-Container mit data-tmodal-target="container" und ID
    const container = document.querySelector(`[data-tmodal-target="container"]#${id}`)
    if (container) {
      const tmodal = container.closest("[data-controller*='tmodal']")
      const btn = tmodal?.querySelector(".modal-button, [data-action*='tmodal#open']")
      if (btn) btn.click()
    }
  }
}
